module.exports = __webpack_public_path__ + "img/one_terminal.e464b96f.png";